import { Typography, useTheme } from '@mui/material';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

import { AnnotatorConceptCard } from './AnnotatorConceptCard';
import { useAnnotatorAnnotationsTab } from './useAnnotatorAnnotationsTab';

export const AnnotatorAnnotationsTab = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const { setAllConceptsExpanded, clearAllConceptsExpanded, annotatorData } =
    useAnnotatorAnnotationsTab();

  if (annotatorData.length <= 0) {
    return (
      <Box>
        <Typography variant="h6">
          {formatMessage({ id: 'supervisorReview.annotatorTab.noAnnotations' })}
        </Typography>
      </Box>
    );
  }
  return (
    <Box>
      <Box sx={{ display: 'flex', gap: theme.spacing(4), cursor: 'pointer' }}>
        <Typography
          onClick={setAllConceptsExpanded}
          variant="body1"
          sx={{ color: theme.palette.primary.main, fontWeight: '400' }}
        >
          {formatMessage({ id: 'workspaceCommon.annotations.expandAllButton' })}
        </Typography>
        <Typography
          onClick={clearAllConceptsExpanded}
          variant="body1"
          sx={{ color: theme.palette.primary.main, fontWeight: '400' }}
        >
          {formatMessage({ id: 'workspaceCommon.annotations.collapseAllButton' })}
        </Typography>
      </Box>
      <Box id="annotator-annotations-tab-concepts">
        {annotatorData.map((item) => (
          <Box key={item.conceptId}>
            <AnnotatorConceptCard
              conceptId={item.conceptId}
              conceptName={item.conceptName}
              annotations={item.annotations}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
